import HeroSection, { CategorySection } from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';
import { SchemaWebPage } from '@/components/feature/SchemaOrg';
import { siteInfo } from '@/mocks/sports';

export default function Home() {
  return (
    <>
      <SchemaWebPage
        url="/"
        name={siteInfo.title}
        description={siteInfo.description}
      />
      <HeroSection />
      <CategorySection />
      <FeaturedArticles />
      <StatsSection />
      <FAQSection />
    </>
  );
}